<!-- =========================================================================================
    File Name: tableFilterSorter.vue
    Description: Add filter and sorting functionality to table
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <b-overlay
    :show="show"
    :variant="variant"
    :opacity="opacity"
    :blur="blur"
    rounded="sm"
    spinner-variant="primary"
  >
    <b-card>
      <h4 class="heading">{{ $t("PinSetting") }}</h4>

      <div class="export-table">
        <label>{{ $t("EnableSetting") }}</label>
        <div class="walk-card">
          <b-form-checkbox
            id="tooltip-target-2"
            v-model="value"
            size="lg"
            name="cell_width"
            @change="pinAction()"
            switch
          >
          </b-form-checkbox>
        </div>

        <b-tooltip target="tooltip-target-2" triggers="hover" placement="right">
          {{ $t("EnableSetting") }}
        </b-tooltip>
      </div>
    </b-card>
  </b-overlay>
</template>

<script>
import { Validator } from "vee-validate";
import $ from "jquery";
import Cookies from "js-cookie";

export default {
  data() {
    return {
      value: true,
      show: false,
      variant: "light",
      opacity: 0.85,
      blur: "2px",
      error: "",
      success: "",
    };
  },
  created() {
    this.getPinSetting();
  },

  methods: {
    /**
     * vee validate with multi lang
     */
    loadLocale(code) {
      return import("vee-validate/dist/locale/" + code).then((locale) => {
        Validator.localize(code, locale);
      });
    },
    getPinSetting() {
      var company_id = this.$store.getters.roles == "assistant" ? this.$store.getters.currentUser.company_id : this.$store.getters.currentUser.id;
      this.$store
        .dispatch("GetPinSetting", company_id)
        .then((res) => {
          this.value = res.data.data.is_pin == 0 ? false : true;
          this.show = false;
        })
        .catch((error) => {
          this.$log.error(
            "File : getPinSetting.vue | Function : getPinSetting() | Error :",
            error
          );
          this.show = false;
          // Error response
          this.error =
            this.$t(error.replace(/[\s\/]/g, "")) !==
            error.replace(/[\s\/]/g, "")
              ? this.$t(error.replace(/[\s\/]/g, ""))
              : error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
          return false;
        });
    },

    /**
     * open popup
     */
    pinAction() {
      var data = {
        is_pin: this.value ? 1 : 0,
        id: this.$store.getters.roles == "assistant" ? this.$store.getters.currentUser.company_id : this.$store.getters.currentUser.id,
      };
      this.$store
        .dispatch("UpdatePinsetting", data)
        .then((res) => {
          this.show = false;

          this.$toasted.show(this.$t("StatusUpdated"), {
            className: "top-alert",
            position: "top-center",
            type: "success",
            duration: 2000,
          });
        })
        .catch((error) => {
          this.$log.error(
            "File : pinAction.vue | Function : pinAction() | Error :",
            error
          );
          this.show = false;
          // Error response
          this.error =
            this.$t(error.replace(/[\s\/]/g, "")) !==
            error.replace(/[\s\/]/g, "")
              ? this.$t(error.replace(/[\s\/]/g, ""))
              : error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
          return false;
        });
    },
  },
};
</script>
